import {
  ApprochablePricing,
  Banner,
  Differences,
  FastResp,
  HowItWorks,
  SavesYou,
  ServiceHighlights,
  Testimonials,
} from "./sections";

export const HomePage = () => {
  return (
    <div className="flex flex-col gap-y-12 md:gap-y-16">
      <Banner />

      <SavesYou />

      <Differences />

      <ServiceHighlights />

      <ApprochablePricing />

      <HowItWorks />

      <FastResp />

      <Testimonials />
    </div>
  );
};
